<template>
  <v-container fluid>
    <loading v-if="loading"></loading>
    <customer-order v-else @orderCreatedAndConfirmed="redirectToFollowOrder"></customer-order>
    <info-alert
        v-model="infoAlertState"
        :text="infoAlertText"
        :alert-type="alertOrderType"
        :alert-font-size="alertOrderFontSize"
    />
  </v-container>
</template>

<script>
import CustomerOrder from "@/modules/delivery/components-core/customer/CustomerOrder/CustomerOrder.vue";
import {CUSTOMER} from "@/modules/delivery/constants/OrderOrigin";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import {Loading} from "@dracul/common-frontend"
import InfoAlert from "@/modules/base/components/InfoAlert";

export default {
  name: "CustomerOrderPage",
  components: {InfoAlert, CustomerOrder, Loading},
  created() {
    this.$nextTick(() => this.init())
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    orderHasIdentifier() {
      return this.$store.getters.orderSystem.order.identifier
    },
    orderIsComplete() {
      return ["DELIVERED", "CANCELED"].includes(this.$store.getters.orderSystem.order.state)
    },
    hasOrder() {
      return this.$store.getters.hasOrder;
    },
    hasOrderIdentifier() {
      return !!this.$store.getters.orderSystem.order.identifier
    },
    orderIdentifier() {
      return this.$store.getters.orderSystem.order.identifier
    },
    //INFO ALERT
    infoAlertState: {
      get() {
        return this.$store.getters.getSettingValue('alertOrderBoolean') && !this.$store.getters.getCurrentOrderIdentifier || false
      },
      set(val) {
        this.$store.commit('setSetting', {key: 'alertOrderBoolean'}, val)
      }
    },
    infoAlertText() {
      return this.$store.getters.getSettingValue('alertOrderText')
    },
    alertOrderType() {
      return this.$store.getters.getSettingValue('alertOrderType')
    },
    alertOrderFontSize() {
      return this.$store.getters.getSettingValue('alertOrderFontSize')
    },
  },
  methods: {
    async init() {
      this.loading = true

      try {
        if (!this.hasOrder) {

          this.$store.dispatch("initOrder", {origin: CUSTOMER})
          this.$store.commit("orderContact", this.$store.getters.lastContact)

        } else if (this.hasOrderIdentifier) {

          //Refresh order
          let r = await OrderProvider.orderFindByIdentifier(this.orderIdentifier)
          this.$store.commit("setupOrder", r.data.orderFindByIdentifier)

          if (this.orderIsComplete) {
            this.$store.commit("clearOrder")
            this.$store.dispatch("initOrder", {origin: CUSTOMER})
          } else {

            return this.redirectToFollowOrder()
          }
        }else{
          this.$store.commit("setOrigin", CUSTOMER)
        }

        this.$store.dispatch("setupOrderSystem")
        this.$store.dispatch("fetchDefaultBranch")

      } catch (e) {
        console.error("Init order error", e)
        setTimeout(() => {
          this.init()
        }, 2000)
        return
      }

      this.loading = false

    },
    redirectToFollowOrder() {
      this.$router.push({
        name: 'CustomerOrderViewPage',
        params: {identifier: this.$store.getters.orderSystem.order.identifier}
      })
    }
  }
}
</script>

<style scoped>

</style>
